/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SchedulingTimeDetails {
    getFixupPrototypeFunction() { return SchedulingTimeDetails.fixupPrototype; }

    static newInstance(model: Partial<SchedulingTimeDetails>): SchedulingTimeDetails {
        let obj = Object.assign(new SchedulingTimeDetails(), model);
        SchedulingTimeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SchedulingTimeDetails>): SchedulingTimeDetails {
        if (!model) return null;
        return SchedulingTimeDetails.newInstance(<SchedulingTimeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SchedulingTimeDetails) {
        if (!obj) return;

        models.SchedulingTimeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SchedulingTimeDetails): boolean {
        Object.setPrototypeOf(obj, SchedulingTimeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Scheduled at which second, allowed values: 0-59
     */
    seconds: string;

    /**
     * Scheduled at which minute, allowed values: 0-59
     */
    minute: string;

    /**
     * Scheduled at which hour, allowed values: 0-23
     */
    hour: string;

}
